module.exports = __webpack_public_path__ + "assets/Napoleon.a926482840ed1c7821cba3219e9bcdf0.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Napoleon.gmt
// module id = 973
// module chunks = 0